import { render, staticRenderFns } from "./SectionOffices.vue?vue&type=template&id=6c1989c5&scoped=true&"
import script from "./SectionOffices.vue?vue&type=script&lang=ts&"
export * from "./SectionOffices.vue?vue&type=script&lang=ts&"
import style0 from "./SectionOffices.vue?vue&type=style&index=0&id=6c1989c5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1989c5",
  null
  
)

export default component.exports